import { Box } from "@mui/material";
import React from "react";

interface IComponent {
    url: string;
    onLoaded?: () => void;
}

const ViewExternalScreen = ({ url, onLoaded }: IComponent) => {
    return (
        <Box
            sx={{
                width: "100%",
                height: "80vh",
                borderRadius: 2,
                overflow: "hidden",
            }}
        >
            <iframe
                src={url}
                style={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                }}
                title="Cockpit"
                onLoad={onLoaded}
            />
        </Box>
    );
};

export default React.memo(ViewExternalScreen);
